var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66392 3.65292H11.6723V0.154917C11.3258 0.10725 10.1342 0 8.74633 0C5.85058 0 3.86692 1.82142 3.86692 5.16908V8.25H0.671417V12.1605H3.86692V22H7.78475V12.1614H10.851L11.3378 8.25092H7.78383V5.55683C7.78475 4.42658 8.08908 3.65292 9.66392 3.65292Z",
    fill: "#273043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a63e607ece9d6ac9f9c522314ae035a2.svg";
export { ForwardRef as ReactComponent };